import {z} from 'zod'

import {zFormRules} from '@/src/config/validation'

export type LoginBeginData = {
  interval: number
}

export type LoginFormData = {
  phone?: string
  code?: string
}

export type CodeFormData = {
  code: string
  phone: string
}

export type LoginFormState = {
  form: 'phone' | 'code'
  options?: LoginBeginData & {phone: string}
  changeForm: (form: LoginFormState['form'], options?: LoginBeginData & {phone: string}) => void
}

export const LoginSchema = z.object({
  phone: zFormRules.phone,
})

export const CodeSchema = z.object({
  code: z.string(),
})

export type CaptchaRenderProps = {
  visible: boolean
  setVisible: (visible: boolean) => void
  onSuccess: (token: string) => void
  renderKey: string
}
